import { useCallback } from 'react';

import { useWorkspaceId } from '@trello/id-context';

import { useClipboardWorkspaceAttachmentRestrictionsFragment } from './ClipboardWorkspaceAttachmentRestrictionsFragment.generated';

export const useCanAddFileType = () => {
  const workspaceId = useWorkspaceId();
  const { data } = useClipboardWorkspaceAttachmentRestrictionsFragment({
    from: { id: workspaceId },
  });
  const attachmentRestrictions = data?.prefs?.attachmentRestrictions;

  const canAddFileType = useCallback(
    (attachmentType: string): boolean => {
      return attachmentRestrictions?.includes(attachmentType) ?? true;
    },
    [attachmentRestrictions],
  );

  return { canAddFileType };
};
